module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/financial-unit-lvl2-100.6d968d81.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/financial-unit-lvl2-100.png
// module id = 3528
// module chunks = 11